<template>
  <div class="fliggy-order-info-bar">
    <img src="../../assets/imgs/ota-order/fliggy.png"  class="fliggy-logo">
    <div class="fliggy-name" v-if="otaInfo.ota_store_name">{{otaInfo.ota_store_name}}</div>
    <a class="fliggy-order-num" @click="showFliggyOrderDetailDialog">{{otaInfo.ota_order_id}}</a>
    <!-- 0:没有创建支付宝交易1:等待买家付款 2:等待卖家发货,即:买家已付款 3:付款以后用户退款成功，交易自动关闭 4:卖家部分发货 5:交易成功 6:等待买家确认收货,即:卖家已发货 7:付款以前，卖家或买家主动关闭交易 8:国际信用卡支付付款确认中 -->
    <div class="fliggy-order-refund-status" v-if="otaInfo.status === 3">
      （已退款）
      <!-- <el-tooltip effect="dark" content="Top Left 提示文字" placement="top">
        <img
          class="question-icon"
          src="../../assets/imgs/product-detail/icon-question.png"
        />
      </el-tooltip> -->
    </div>
  </div>
</template>

<script>
import FliggyOrderDetailDialog from './fliggy-order-detail-dialog/index';

export default {
  components: {
  },
  props: {
    otaInfo: {  
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {};
  },
  computed: {},
  created() {},
  methods: {
    showFliggyOrderDetailDialog() {
      FliggyOrderDetailDialog.show({
        ota_sub_order_id: this.otaInfo.ota_sub_order_id,
        onRefresh: () => {
          this.$emit('refresh');
        },
      });
    },
  },
};
</script>


<style lang="less" scoped>
.fliggy-order-info-bar{
  display: flex;
  align-items: center;
  font-size: 14px;
  .fliggy-logo {
    width: 22px;
    flex-shrink: 0;
  }
  .fliggy-name {
    margin-left: 10px;
    flex-shrink: 1;
    max-width: 230px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #777777;
  }
  .fliggy-order-num {
    margin-left: 5px;
    color: #777;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex-shrink: 0;
    color: #5e9be1;
  }
  .fliggy-order-refund-status{
    display: flex;
    align-items: center;
    color: #FF5A60;
    .question-icon{
      margin-left: 4px;
      width: 16px;
      height: 16px;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ota/fliggy-order-info-bar.vue